module.exports = __webpack_public_path__ + "img/logo5.614ba31f.svg";